import { createPopper } from '@popperjs/core';
import bootstrap from 'bootstrap';
$ = window.$ = window.jQuery = require('jquery');

window.initInstantSearch = async function(config = {}) {
    const { initInstantSearch } = await import(
        /* webpackChunkName: "instantsearch" */
        './modules/instantsearch'
    );

    return initInstantSearch(config);
};

window.initKnowledgeBaseAutocomplete = async function(config = {}) {
    const { initKnowledgeBaseAutocomplete } = await import(
        /* webpackChunkName: "instantsearch" */
        './modules/instantsearch'
    );

    return initKnowledgeBaseAutocomplete(config);
};

window.initRelatedProducts = async function(config = {}) {
    const { initRelatedProducts } = await import(
        /* webpackChunkName: "instantsearch" */
        './modules/instantsearch'
    );

    return initRelatedProducts(config);
};

window.initRelatedKnowledgeBase = async function(config = {}) {
    const { initRelatedKnowledgeBase } = await import(
        /* webpackChunkName: "instantsearch" */
        './modules/instantsearch'
    );

    return initRelatedKnowledgeBase(config);
};

import Swiper from 'swiper';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const heroSwiper = new Swiper('.hero-unit .swiper', {
    modules: [Autoplay, EffectFade],
    loop: true,
    spaceBetween: 0,
    autoplay: {
        delay: 2500,
    },
    effect: 'fade',
    speed: 1000,
    fadeEffect: {
        crossFade: true,
    },
});

const newsSwiper = new Swiper('.latest-news .swiper', {
    modules: [Navigation],
    spaceBetween: 20,
    slidesPerView: 'auto',
    breakpoints: {
        576: {
            slidesPerView: 'auto',
            spaceBetween: 20
        },
        768: {
            slidesPerView: 2,
            spaceBetween: 30
        },
        992: {
            slidesPerView: 3,
            spaceBetween: 30
        }
    },
    navigation: {
        nextEl: '.latest-news .swiper-button-next',
        prevEl: '.latest-news .swiper-button-prev',
    },
});

const casesSwiper = new Swiper('.latest-cases .swiper', {
    modules: [Navigation],
    spaceBetween: 20,
    slidesPerView: 'auto',
    breakpoints: {
        576: {
            slidesPerView: 'auto',
            spaceBetween: 20
        },
        768: {
            slidesPerView: 2,
            spaceBetween: 30
        },
        992: {
            slidesPerView: 3,
            spaceBetween: 30
        }
    },
    navigation: {
        nextEl: '.latest-cases .swiper-button-next',
        prevEl: '.latest-cases .swiper-button-prev',
    },
});

const relatedNewsSwiper = new Swiper('.platform-related-news .swiper', {
    modules: [Navigation],
    spaceBetween: 20,
    slidesPerView: 'auto',
    breakpoints: {
        576: {
            slidesPerView: 'auto',
            spaceBetween: 20
        },
        768: {
            slidesPerView: 2,
            spaceBetween: 30
        },
    },
    navigation: {
        nextEl: '.platform-related-news .swiper-button-next',
        prevEl: '.platform-related-news .swiper-button-prev',
    },
});

const relatedCasesSwiper = new Swiper('.platform-related-cases .swiper', {
    modules: [Navigation],
    spaceBetween: 20,
    slidesPerView: 'auto',
    breakpoints: {
        576: {
            slidesPerView: 'auto',
            spaceBetween: 20
        },
        768: {
            slidesPerView: 2,
            spaceBetween: 30
        },
    },
    navigation: {
        nextEl: '.platform-related-cases .swiper-button-next',
        prevEl: '.platform-related-cases .swiper-button-prev',
    },
});

const kbFeaturedDocumentsEl = document.querySelector('.kb-featured-documents .swiper');
const kbFeaturedDocumentsSlidesDesktop = Number(kbFeaturedDocumentsEl?.dataset.swiperSlidesDesktop || 3);
const kbFeaturedDocumentsSwiper = new Swiper('.kb-featured-documents .swiper', {
    modules: [Navigation, Pagination],
    spaceBetween: 20,
    slidesPerView: 1.1,
    autoHeight: true,
    pagination: {
        el: '.kb-featured-documents .swiper-pagination',
        clickable: true
    },
    breakpoints: {
        576: {
            slidesPerView: 'auto',
            spaceBetween: 8
        },
        768: {
            slidesPerView: 2,
            spaceBetween: 12
        },
        992: {
            slidesPerView: kbFeaturedDocumentsSlidesDesktop,
            spaceBetween: 16
        }
    },
    navigation: {
        nextEl: '.kb-featured-documents .swiper-button-next',
        prevEl: '.kb-featured-documents .swiper-button-prev',
    },
});

import smoothScroll from 'jquery-smooth-scroll/src/jquery.smooth-scroll';
$('a[href*="#"]:not(.skip-scroll)').smoothScroll({
    offset: -192,
    speed: 350
});


window.addEventListener("scroll", function(){

    let windowThis = this;

    setTimeout(() => {
        if(windowThis.scrollY > 0) {
            document.body.classList.add('offset');
        } else {
            document.body.classList.remove('offset');
        }
    }, 250);
});

const offcanvasSearch = document.getElementById('offcanvasSearch')
offcanvasSearch.addEventListener('shown.bs.offcanvas', event => {
    $("#offcanvasSearch input[name=q]").focus();
})
